import React, { useCallback, useMemo } from "react";
import { View } from "react-native";
import { useI18nMessage } from "@lookiero/i18n-react";
import { Segment } from "@lookiero/sty-psp-segment";
import { Button } from "../../../../atom/button/Button";
import { useAnswerForId } from "../../behaviours/useAnswers";
import { useAnswersValidation } from "../../behaviours/useAnswersValidation";
import { QuestionItemState, useQuestionItemState } from "../../behaviours/useQuestionItemState";
import { style as strikeOutAvoidButtonWithIconQuestionItemStyle } from "./StrikeOutAvoidButtonWithIconQuestionItem.style";
const ICON = {
    ["quiz.icon.dresses"]: "dress_large",
    ["style_profile.icon.dresses"]: "dress_large",
    ["quiz.icon.shirts"]: "shirt_large",
    ["style_profile.icon.shirts"]: "shirt_large",
    ["quiz.icon.t_shirts"]: "t_shirt_round_large",
    ["style_profile.icon.t_shirts"]: "t_shirt_round_large",
    ["quiz.icon.trousers"]: "trousers_large",
    ["style_profile.icon.trousers"]: "trousers_large",
    ["quiz.icon.skirts"]: "skirt_large",
    ["style_profile.icon.skirts"]: "skirt_large",
    ["quiz.icon.outwear"]: "outer_garment_large",
    ["style_profile.icon.outwear"]: "outer_garment_large",
    ["quiz.icon.bags"]: "bag_large",
    ["style_profile.icon.bags"]: "bag_large",
    ["quiz.icon.foulards"]: "scarf_large",
    ["style_profile.icon.foulards"]: "scarf_large",
    ["quiz.icon.footwear"]: "shoes_large",
    ["style_profile.icon.footwear"]: "shoes_large",
    ["quiz.icon.prints"]: "t_shirt_graphics_large",
    ["style_profile.icon.prints"]: "t_shirt_graphics_large",
    ["quiz.icon.v_neck_t_shirt"]: "t_shirt_v_large",
    ["style_profile.icon.v_neck_t_shirt"]: "t_shirt_v_large",
    ["quiz.icon.polo_shirt"]: "polo",
    ["style_profile.icon.polo_shirt"]: "polo",
    ["quiz.icon.jumper"]: "sweater_large",
    ["style_profile.icon.jumper"]: "sweater_large",
    ["quiz.icon.jeans"]: "denim_large",
    ["style_profile.icon.jeans"]: "denim_large",
    ["quiz.icon.shorts"]: "shorts_large",
    ["style_profile.icon.shorts"]: "shorts_large",
};
const ICON_CHECKED = {
    ["quiz.icon.dresses"]: "dress_large_avoid",
    ["style_profile.icon.dresses"]: "dress_large_avoid",
    ["quiz.icon.shirts"]: "shirt_large_avoid",
    ["style_profile.icon.shirts"]: "shirt_large_avoid",
    ["quiz.icon.t_shirts"]: "t_shirt_round_large_avoid",
    ["style_profile.icon.t_shirts"]: "t_shirt_round_large_avoid",
    ["quiz.icon.trousers"]: "trousers_large_avoid",
    ["style_profile.icon.trousers"]: "trousers_large_avoid",
    ["quiz.icon.skirts"]: "skirt_large_avoid",
    ["style_profile.icon.skirts"]: "skirt_large_avoid",
    ["quiz.icon.outwear"]: "outer_garment_large_avoid",
    ["style_profile.icon.outwear"]: "outer_garment_large_avoid",
    ["quiz.icon.bags"]: "bag_large_avoid",
    ["style_profile.icon.bags"]: "bag_large_avoid",
    ["quiz.icon.foulards"]: "scarf_large_avoid",
    ["style_profile.icon.foulards"]: "scarf_large_avoid",
    ["quiz.icon.footwear"]: "shoes_large_avoid",
    ["style_profile.icon.footwear"]: "shoes_large_avoid",
    ["quiz.icon.prints"]: "t_shirt_graphics_large_avoid",
    ["style_profile.icon.prints"]: "t_shirt_graphics_large_avoid",
    ["quiz.icon.v_neck_t_shirt"]: "t_shirt_v_large_avoid",
    ["style_profile.icon.v_neck_t_shirt"]: "t_shirt_v_large_avoid",
    ["quiz.icon.polo_shirt"]: "polo_avoid",
    ["style_profile.icon.polo_shirt"]: "polo_avoid",
    ["quiz.icon.jumper"]: "sweater_large_avoid",
    ["style_profile.icon.jumper"]: "sweater_large_avoid",
    ["quiz.icon.jeans"]: "denim_large_avoid",
    ["style_profile.icon.jeans"]: "denim_large_avoid",
    ["quiz.icon.shorts"]: "shorts_large_avoid",
    ["style_profile.icon.shorts"]: "shorts_large_avoid",
};
const iconForSegment = ({ iconName, segment, checked }) => {
    if ((iconName === "quiz.icon.outwear" || iconName === "style_profile.icon.outwear") && segment === Segment.MEN) {
        return checked ? "jacket_large_avoid" : "jacket_large";
    }
    return checked ? ICON_CHECKED[iconName] : ICON[iconName];
};
const StrikeOutAvoidButtonWithIconQuestionItem = ({ domain, segment, question, questionParentId, }) => {
    const titleText = useI18nMessage({ domain, id: question.translationKey, values: { segment: segment.toLowerCase() } });
    const { answer, onChange } = useAnswerForId({ id: questionParentId });
    const selectedAnswer = answer && answer.find((id) => id === question.id);
    const { validateMaxAnswers } = useAnswersValidation();
    const state = useQuestionItemState({ questionParentId, question });
    const handleOnChange = useCallback(() => {
        onChange({ questionId: question.id, answer: selectedAnswer ? undefined : question.id });
        validateMaxAnswers();
    }, [onChange, question.id, selectedAnswer, validateMaxAnswers]);
    const checked = state === QuestionItemState.SELECTED;
    const iconName = question.metadata.icon;
    const icon = iconForSegment({ iconName, segment, checked });
    const style = useMemo(() => strikeOutAvoidButtonWithIconQuestionItemStyle(), []);
    return (React.createElement(View, { style: style.container, testID: "strike-out-avoid-button-with-icon-question-item" },
        React.createElement(Button, { checked: checked, icon: icon, style: { button: style.button, icon: style.icon, text: checked ? [style.text, style.textChecked] : style.text }, testID: question.id, title: titleText, onPress: handleOnChange })));
};
export { StrikeOutAvoidButtonWithIconQuestionItem };
